import { get } from 'lodash';

export class DeclarationForm {
  summary: boolean | undefined;
  term: boolean | undefined;
  declaration: boolean | undefined;
  required1: boolean | undefined;
  required2: boolean | undefined;
  required3:  boolean | undefined;

  constructor(initial: any) {
    this.summary = get(initial, 'summary', undefined);
    this.term = get(initial, 'term', undefined);
    this.declaration =  get(initial, 'declaration', undefined);
    this.required1 =  get(initial, 'required1', undefined);
    this.required2 = get(initial, 'required2', undefined);
    this.required3 = get(initial, 'required3', undefined);
  }

  get reviewDeclaration(): { text: string, value: string }[]  {
    return [
      { text: 'I have downloaded, fully read and understood the product summary', value: this.getAnswer(this.summary) },
      { text: 'I have downloaded, fully read and understood the policy terms and conditions', value: this.getAnswer(this.term)},
      { text: 'I have downloaded, fully read and agreed to the statements described in this declaration document', value: this.getAnswer(this.declaration)},
      { text: 'I have completed and disclosed fully and truthfully all the information requested for in this application', value: this.getAnswer(this.required1 )},
      { text: 'I am purchasing the plan without any advice from a financial adviser representive and I take responsibility to ensure that this plan suits my needs', value: this.getAnswer(this.required2) },
      { text: 'I am physically present in Singapore at the time of this application submission', value:  this.getAnswer(this.required3)},

    ];
  }
  
  getAnswer(input: boolean | undefined) {
    return input ? 'Yes' : 'No';
  }
}

export interface IReadDocs {
  isReadProduct: boolean;
  isReadTerms: boolean;
  isReadDeclare: boolean;
}